import { Box, Collapse, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  addReferralForPatientByTrainer,
  getModulesInArea,
  putAddReferralForPatient,
} from "../../../api/area";
import DownArrow from "../../../assets/SVG/downArrow";
import ReferralIcon from "../../../assets/SVG/referralIcon";
import { useSearchParams } from "react-router-dom";

export default function Referral({ data, label, fromModuleId, amozesh }) {
  const [moduleInArea, setModuleInArea] = useState();
  const [collapseReferral, setCollapseReferral] = useState();
  const [selectedModule, setSelectedModule] = useState([]);
  const md = useMediaQuery("(max-width:450px)");
  const [params] = useSearchParams();
  const [areaId] = useMemo(() => {
    return [params.get("areaId")];
  }, [params]);

  let Array = [];

  useEffect(() => {
    if (selectedModule) {
      selectedModule?.map((x) => {
        if (x !== "" && x !== undefined) {
          Array.push(x);
        }
      });
    }
  }, [selectedModule]);
  useEffect(() => {
    if (collapseReferral) {
      getModulesInArea(areaId)
        .then((x) => setModuleInArea(x))
        .catch(() => {});
    }
  }, [collapseReferral]);
  return (
    <>
      <Box
        onClick={() => setCollapseReferral(!collapseReferral)}
        bgcolor="#EFF1F7"
        borderRadius={"7px"}
        p="10px"
        display="flex"
        justifyContent={"space-between"}
        alignItems="center"
        sx={{ cursor: "pointer" }}
        mt="20px"
      >
        <Typography color="var(--emr-darkblue)">
          {label || "ارجاع به دیگر بخش ها"}
        </Typography>
        <DownArrow transform={collapseReferral} />
      </Box>
      <Collapse in={collapseReferral} timeout="auto">
        <Box mt="-5px" bgcolor="#EFF1F7" p="10px">
          <Box display="flex" flexWrap="wrap" gap="20px" mt="20px">
            {moduleInArea?.map((x, i) => (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={md ? "90px" : "150px"}
                height={md ? "60px" : "110px"}
                bgcolor={"#F5F9FF"}
                boxShadow={"0px 2px 4px 0px #00000040"}
                borderRadius="13px"
                border={
                  selectedModule[i] === x.moduleId
                    ? "solid 3px var(--emr-darkblue)"
                    : "solid 3px #F5F9FF"
                }
                sx={{ cursor: "pointer", transition: "0.3s all" }}
                onClick={(e) => {
                  setSelectedModule((z) => {
                    let array = [...z];
                    array[i] !== x.moduleId
                      ? (array[i] = x.moduleId)
                      : (array[i] = "");
                    // console.log(array);
                    return array;
                  });
                }}
              >
                <Typography
                  color={
                    setSelectedModule[i] === x.moduleId
                      ? "var(--emr-darkblue)"
                      : "#909090"
                  }
                  fontWeight="bold"
                  variant={md ? "caption" : "body1"}
                  textAlign={"center"}
                >
                  {x.moduleName}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box mt="10px" display="flex" justifyContent="end">
            <Box
              style={{
                border: "none",
                backgroundColor: "#E09856",
                color: "white",
                padding: "5px 40px",
                borderRadius: "10px",
                marginLeft: "10px",
                cursor: "pointer",
                display: "flex",
                gap: "5px",
                alignItems: "center",
              }}
              onClick={() => {
                selectedModule.map((key) => {
                  if (key !== "" && key !== undefined) {
                    if (amozesh) {
                      addReferralForPatientByTrainer(areaId, key, data?.id)
                        .then(() => {
                          toast.success("ارجاع داده شد");
                        })
                        .catch(() => {});
                    } else {
                      putAddReferralForPatient(
                        areaId,
                        fromModuleId,
                        key,
                        data?.id,
                      )
                        .then(() => {
                          toast.success("ارجاع داده شد");
                        })
                        .catch(() => {});
                    }
                  }
                });
              }}
            >
              <ReferralIcon />
              <Typography color="white">{"ارجاع"}</Typography>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </>
  );
}
